import _debounce from 'lodash/debounce';
import React, { ChangeEvent, Component, PropsWithChildren, KeyboardEvent } from 'react';
import posed from 'react-pose';
import { Icon } from '../';
import { IGridSearchProps } from './types';

import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

import { ThemeProvider } from 'styled-components';
import './GridSearch.scss';

export interface IGridSearchState {
  expanded: boolean;
  searchTriggered: boolean;
  value: string;
}

const PosedDiv = posed.div({
  closed: {
    applyAtStart: { overflow: 'hidden' },
    marginLeft: 0,
    opacity: 0,
    width: 0,
  },
  expanded: {
    applyAtEnd: { overflow: 'auto' },
    marginLeft: 10,
    opacity: 1,
    width: 'auto',
  },
});

export class GridSearch extends Component<PropsWithChildren<IGridSearchProps>, IGridSearchState> {
  public input: HTMLInputElement | null;
  public state = {
    expanded: false,
    searchTriggered: false,
    value: '',
  };
  private handleUpdate = _debounce((value: string) => {
    this.setState({ searchTriggered: true });
    this.props.onChange('search', value);
  }, 1000);

  public componentDidUpdate(prevProps: IGridSearchProps) {
    if (prevProps.loading && !this.props.loading && this.state.searchTriggered && this.state.expanded && this.input) {
      this.setState({ searchTriggered: false });
      this.input.focus();
    }
  }

  public toggleExpand = () => {
    this.setState(
      (prevState) => ({ expanded: !prevState.expanded }),
      () => {
        if (this.state.expanded && this.input) {
          this.input.focus();
        }
      },
    );
  };

  public handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({ value });
    this.handleUpdate(value);
  };
  public handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    if (e.keyCode === 13) {
      e.preventDefault();
      this.setState({ value });
      this.props.onChange('search', value);
      this.handleUpdate.cancel();
    }
  };

  public handleCancel = () => {
    this.setState({ value: '' });
    this.handleUpdate('');
  };
  public render() {
    const { loading = false } = this.props;
    const { expanded, value } = this.state;

    return (
      <div className="hlc-datagrid-search-wrapper">
        <ThemeProvider theme={{ iconBackgroundOffsetTop: '1px' }}>
          <Icon
            title="Search"
            className="hlc-datagrid-search-icon"
            icon={faSearch}
            size={'lg'}
            onClick={this.toggleExpand}
          />
        </ThemeProvider>

        <PosedDiv className="hlc-datagrid-search-input-wrapper" pose={this.state.expanded ? 'expanded' : 'closed'}>
          <input
            ref={(ref) => (this.input = ref)}
            className="form-control"
            name="hlc-datagrid-search"
            value={value}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            tabIndex={expanded ? 0 : -1}
            disabled={loading}
            data-testid="grid-search-input"
          />
          {!!value.length && (
            <Icon
              qa-id={this.props['qa-id']}
              title="Clear search"
              icon={faTimesCircle}
              className="hlc-datagrid-search-clear-icon"
              onClick={this.handleCancel}
            />
          )}
        </PosedDiv>
      </div>
    );
  }
}
export default GridSearch;
